"use client";

import { useEffect, useState } from "react";
import { setUser } from "@sentry/nextjs";
import { createClientComponentClient } from "@supabase/auth-helpers-nextjs";
import { User } from "@supabase/auth-helpers-nextjs";

interface UserProfile {
  id: string;
  account_type: string | null;
  [key: string]: any;
}

interface SentryUserTrackerProps {
  profile?: UserProfile | null;
}

/**
 * Component that tracks user context in Sentry with profile.id and profile.account_type
 */
export function SentryUserTracker({ profile }: SentryUserTrackerProps) {
  const [user, setCurrentUser] = useState<User | null>(null);
  const supabase = createClientComponentClient();

  useEffect(() => {
    // Get initial user
    supabase.auth.getUser().then(({ data: { user } }) => {
      setCurrentUser(user);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setCurrentUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, [supabase]);

  useEffect(() => {
    if (user && profile) {
      setUser({
        id: user.id,
        email: user.email || undefined,
        segment: profile.account_type || "unknown",
        data: {
          profileId: profile.id,
          accountType: profile.account_type || "unknown",
        },
      });
    } else {
      setUser(null);
    }
  }, [user, profile]);

  return null;
}
